




















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ICartCourse, ILoginCredentials, IParentProfile, IStudentListItem, IPaypalItem, ICalendarSession, IPriceTier, ICalendar, IStudentListCartItem } from '@/interfaces';
import { CartGetters, UserGetters } from '@/Getters';
import { AjaxHelper } from '@/AjaxHelper';

import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';
import Btn from '@/components/Btn.vue';
import LoginForm from '@/components/forms/LoginForm.vue';
import Splitter from '@/components/Splitter.vue';

@Component({
  name: 'cart-details-cart-step-page',
  components: { List, ListItem, Btn, LoginForm, Splitter }
})
export default class CartDetailsCartStepComponent extends Vue {
  public get cartItems(): ICartCourse[] { return this.$store.getters[CartGetters.getCourses]; }
  public get isAuthenticated(): boolean { return this.$store.getters[UserGetters.isAuthenticated]; }

  /**
   * Remove an item from the cart
   * 
   * @param item The cart course item that should be removed
   */
  public async removeFromCart(item: ICartCourse) {
    try {
      await this.$store.dispatch('removeCourseFromCart', item);
      this.$alert.success('Removed From Cart', `${item.fullName} has been removed`);
    } catch {
      this.$alert.danger('Error occured while removing item from cart');
    }
  }

  /**
   * Method that will be called once the login occurs
   * 
   * @param model The loginc cred model
   */
  public async login(model: ILoginCredentials) {
    await this.$store.dispatch('login', model);
    this.$router.push('/');
  }

  /**
   * Helper method to move to the next step
   */
  public async nextStep() {
    if (this.isAuthenticated) {
      this.$emit('next');
    } else {
      this.$alert.warning('Cannot move to next step as anonymous');
    }
  }
}
